<template>
    <breeze-authenticated-layout>
        <template #header>
            <div class="flex justify-between items-center">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    component/Ux
                </h2>

                <button
                    @click="open = true"
                    class="
                        py-1
                        px-2
                        bg-indigo-500
                        text-white
                        rounded
                        focus:outline-none
                    "
                >
                    Add
                </button>
            </div>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6 bg-white border-b border-gray-200">
                        <div class="flex flex-col">
                            <div
                                class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8"
                            >
                                <div
                                    class="
                                        py-2
                                        align-middle
                                        inline-block
                                        min-w-full
                                        sm:px-6
                                        lg:px-8
                                    "
                                >
                                    <div
                                        class="
                                            shadow
                                            overflow-hidden
                                            border-b border-gray-200
                                            sm:rounded-lg
                                        "
                                    >
                                        <table
                                            class="
                                                min-w-full
                                                divide-y divide-gray-200
                                            "
                                        >
                                            <thead class="bg-gray-50">
                                                <tr>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        #
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            relative
                                                            px-6
                                                            py-3
                                                        "
                                                    >
                                                        <span class="sr-only"
                                                        >Edit</span
                                                        >
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Field Label
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Group Id
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Field Type
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Name
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Lables
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Values
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Order Id
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Live
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody
                                                class="
                                                    bg-white
                                                    divide-y divide-gray-200
                                                "
                                            >
                                                <tr
                                                    v-for="(
                                                        component, index
                                                    ) in components"
                                                    :key="component.id"
                                                >
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ index + 1 }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                            text-right text-sm
                                                            font-medium
                                                        "
                                                    >
                                                        <button

                                                            @click="destroy(component)"
                                                            class="
                                                                text-red-400
                                                                hover:text-red-600
                                                                mx-3
                                                                focus:outline-none
                                                            "
                                                        >
                                                            Delete
                                                        </button>
                                                        <button
                                                            type="button"
                                                            @click="
                                                                edit(component)
                                                            "
                                                            class="
                                                                text-green-600
                                                                hover:text-green-900
                                                                mx-3
                                                                focus:outline-none
                                                            "
                                                        >
                                                            Edit
                                                        </button>
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ component.label }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ component.group_id }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ component.type }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ component.name }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        Label One:
                                                        {{
                                                            component.options
                                                                .label_one
                                                        }}<br />
                                                        Label Two:
                                                        {{
                                                            component.options
                                                                .label_two
                                                        }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        Min Value:
                                                        {{
                                                            component.options
                                                                .min_value
                                                        }}<br />
                                                        Max Value:
                                                        {{
                                                            component.options
                                                                .max_value
                                                        }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{
                                                            component.order_number
                                                        }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        <span
                                                            :class="{
                                                                'bg-green-100 text-green-800':
                                                                    component.live,
                                                                'bg-red-100 text-red-800':
                                                                    !component.live,
                                                            }"
                                                            class="
                                                                px-2
                                                                inline-flex
                                                                text-xs
                                                                leading-5
                                                                font-semibold
                                                                rounded-full
                                                            "
                                                        >
                                                            {{
                                                                component.live
                                                                    ? "Yes"
                                                                    : "No"
                                                            }}
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </breeze-authenticated-layout>
    <dialog-model :show="open" @close="close">
        <template v-slot:title> {{ title }} </template>
        <template v-slot:content>
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div class="block w-full">
                    <label
                        for="group_id"
                        class="block text-sm font-medium text-gray-700"
                        >Group/Exercise Id</label
                    >
                    <select
                        v-model="form.group_id"
                        id="field_type"
                        name="field_type"
                        autocomplete="off"
                        class="
                            mt-1
                            block
                            w-full
                            py-2
                            px-3
                            border border-gray-300
                            bg-white
                            rounded-md
                            shadow-sm
                            focus:outline-none
                            focus:ring-indigo-500
                            focus:border-indigo-500
                            sm:text-sm
                        "
                    >
                        <option value="">Select group id</option>
                        <option :value="id" :key="id" v-for="id in group_id">{{id}}</option>
                    </select>
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.report_component.group_id"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="field_label"
                        class="block text-sm font-medium text-gray-700"
                        >Field Lable</label
                    >
                    <input
                        v-model="form.field_label"
                        type="text"
                        name="field_label"
                        id="field_label"
                        class="
                            mt-1
                            focus:ring-indigo-500 focus:border-indigo-500
                            block
                            w-full
                            shadow-sm
                            sm:text-sm
                            border-gray-300
                            rounded-md
                        "
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.report_component.field_label"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="name"
                        class="block text-sm font-medium text-gray-700"
                        >Name</label
                    >
                    <input
                        v-model="form.name"
                        type="text"
                        name="name"
                        id="name"
                        class="
                            mt-1
                            focus:ring-indigo-500 focus:border-indigo-500
                            block
                            w-full
                            shadow-sm
                            sm:text-sm
                            border-gray-300
                            rounded-md
                        "
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.report_component.name"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="field_type"
                        class="block text-sm font-medium text-gray-700"
                        >Field Type</label
                    >
                    <select
                        v-model="form.field_type"
                        id="field_type"
                        name="field_type"
                        autocomplete="off"
                        class="
                            mt-1
                            block
                            w-full
                            py-2
                            px-3
                            border border-gray-300
                            bg-white
                            rounded-md
                            shadow-sm
                            focus:outline-none
                            focus:ring-indigo-500
                            focus:border-indigo-500
                            sm:text-sm
                        "
                    >
                        <option value="">Select Field Type</option>
                        <option value="radio">Radio</option>
                        <option value="slider">Slider</option>
                    </select>
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.report_component.field_type"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="label_one"
                        class="block text-sm font-medium text-gray-700"
                        >Label One</label
                    >
                    <input
                        v-model="form.label_one"
                        type="text"
                        name="label_one"
                        id="label_one"
                        class="
                            mt-1
                            focus:ring-indigo-500 focus:border-indigo-500
                            block
                            w-full
                            shadow-sm
                            sm:text-sm
                            border-gray-300
                            rounded-md
                        "
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.report_component.label_one"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="label_two"
                        class="block text-sm font-medium text-gray-700"
                        >Label Two</label
                    >
                    <input
                        v-model="form.label_two"
                        type="text"
                        name="label_two"
                        id="label_two"
                        class="
                            mt-1
                            focus:ring-indigo-500 focus:border-indigo-500
                            block
                            w-full
                            shadow-sm
                            sm:text-sm
                            border-gray-300
                            rounded-md
                        "
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.report_component.label_two"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="min_value"
                        class="block text-sm font-medium text-gray-700"
                        >Min Value</label
                    >
                    <input
                        v-model="form.min_value"
                        type="number"
                        name="min_value"
                        id="min_value"
                        class="
                            mt-1
                            focus:ring-indigo-500 focus:border-indigo-500
                            block
                            w-full
                            shadow-sm
                            sm:text-sm
                            border-gray-300
                            rounded-md
                        "
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.report_component.min_value"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="max_value"
                        class="block text-sm font-medium text-gray-700"
                        >Max Value</label
                    >
                    <input
                        v-model="form.max_value"
                        type="number"
                        name="max_value"
                        id="max_value"
                        class="
                            mt-1
                            focus:ring-indigo-500 focus:border-indigo-500
                            block
                            w-full
                            shadow-sm
                            sm:text-sm
                            border-gray-300
                            rounded-md
                        "
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.report_component.max_value"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="order_number"
                        class="block text-sm font-medium text-gray-700"
                        >Order Number</label
                    >
                    <input
                        v-model="form.order_number"
                        type="number"
                        name="order_number"
                        id="order_number"
                        class="
                            mt-1
                            focus:ring-indigo-500 focus:border-indigo-500
                            block
                            w-full
                            shadow-sm
                            sm:text-sm
                            border-gray-300
                            rounded-md
                        "
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.report_component.order_number"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="live"
                        class="block text-sm font-medium text-gray-700"
                        >Live</label
                    >
                    <select
                        v-model="form.live"
                        id="live"
                        name="live"
                        autocomplete="off"
                        class="
                            mt-1
                            block
                            w-full
                            py-2
                            px-3
                            border border-gray-300
                            bg-white
                            rounded-md
                            shadow-sm
                            focus:outline-none
                            focus:ring-indigo-500
                            focus:border-indigo-500
                            sm:text-sm
                        "
                    >
                        <option value="">Component is Live or not?</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.report_component.live"
                    />
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <button
                type="button"
                class="
                    w-full
                    inline-flex
                    justify-center
                    rounded-md
                    border border-transparent
                    shadow-sm
                    px-4
                    py-2
                    bg-green-600
                    text-base
                    font-medium
                    text-white
                    hover:bg-green-700
                    focus:outline-none
                    focus:ring-2
                    focus:ring-offset-2
                    focus:ring-green-500
                    sm:ml-3 sm:w-auto sm:text-sm
                "
                @click="submit()"
            >
                Save
            </button>
            <button
                type="button"
                class="
                    mt-3
                    w-full
                    inline-flex
                    justify-center
                    rounded-md
                    border border-gray-300
                    shadow-sm
                    px-4
                    py-2
                    bg-white
                    text-base
                    font-medium
                    text-gray-700
                    hover:bg-gray-50
                    focus:outline-none
                    focus:ring-2
                    focus:ring-offset-2
                    focus:ring-indigo-500
                    sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm
                "
                @click="close()"
                ref="cancelButtonRef"
            >
                Cancel
            </button>
        </template>
    </dialog-model>
</template>
<script>
import BreezeAuthenticatedLayout from "@/Layouts/Authenticated";
import DialogModel from "@/Components/DialogModel";
import InputError from "@/Components/InputError";
import { useForm } from "@inertiajs/inertia-vue3";
export default {
    data() {
        return {
            open: false,
            editItemIndex: -1,
            form: useForm(
                {
                    id: "",
                    group_id: "",
                    name: "",
                    label_one: "",
                    label_two: "",
                    field_label: "",
                    field_type: "",
                    min_value: "",
                    max_value: "",
                    order_number: "",
                    live: "",
                },
                {
                    bag: "report_component",
                }
            ),
        };
    },
    watch: {
        "form.field_label": {
            immediate: true,
            handler() {
                if (this.form.field_label) {
                    this.form.name = this.form.field_label
                        .toLowerCase()
                        .replace(" ", "_");
                } else {
                    this.form.name = "";
                }
            },
        },
    },
    props: {
        components: Array,
        group_id: Array,
    },
    computed: {
        title() {
            return this.editItemIndex > -1
                ? "Edit This component"
                : "Add a new component";
        },
    },
    methods: {
        close() {
            this.form.clearErrors();
            this.form.reset();
            this.open = false;
            this.editItemIndex = -1;
        },
        submit() {
            if (this.editItemIndex > -1) {
                // update request
                this.form.put(
                    route(`admin.report-component.update`, {'report_component': this.form.id, _query: {for: 'body_3_area_2'}}),
                    {
                        onSuccess: () => this.close(),
                        preserveScroll: true,
                    }
                );
            } else {
                // store request
                this.form.post(route(`admin.report-component.store`,{_query: {for: 'body_3_area_2'}}), {
                    onSuccess: () => this.close(),
                    preserveScroll: true,
                });
            }
        },
        edit(component) {
            this.editItemIndex = this.components.indexOf(component);
            this.form.group_id = component.group_id;
            this.form.name = component.name;
            this.form.label_one = component.options.label_one;
            this.form.label_two = component.options.label_two;
            this.form.field_label = component.label;
            this.form.field_type = component.type;
            this.form.order_number = component.order_number;
            this.form.max_value = component.options.max_value;
            this.form.min_value = component.options.min_value;
            this.form.live = component.live ? 1 : 0;
            this.form.id = component.id;
            this.open = true;
        },
        destroy(component){
            if(confirm('Are you sure about deleting this item?')){
                this.$inertia.delete(route(`admin.report-component.destroy`,component.id))
            }
        },
    },
    components: {
        BreezeAuthenticatedLayout,
        DialogModel,
        InputError,
    },
};
</script>
